import React, { FC } from 'react';
import styled from '@emotion/styled';
import { IIUserReview } from '$models';
import { Flex } from '$components/layouts';
import { IconReview } from '$components/elements/icon-review';

type UserReviewProps = {
    review: IIUserReview;
};

export const UserReview: FC<UserReviewProps> = ({ review }: UserReviewProps): JSX.Element => {
    return (
        <StyledReview>
            <StyledHeader alignItems={'center'} gap={'small'}>
                <IconReview score={review.score || 0} />
                <div>{review.userRealName}</div>
            </StyledHeader>
            <p>{review.review}</p>
        </StyledReview>
    );
};

const StyledReview = styled.div(({ theme }) => ({
    paddingBottom: theme.space[3],
    marginBottom: theme.space[3],
    borderBottom: `1px solid ${theme.colors.primaryGreyLight}`,
    fontSize: theme.fontSizes.sm,
}));

const StyledHeader = styled(Flex)(({ theme }) => ({
    marginBottom: theme.space[3],
    fontStyle: 'italic',
}));
